/**
 * 系统管理  学习平台
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学习平台</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryParams.query.learnPlatformCode" placeholder="输入学习平台编码"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.query.learnPlatformName" placeholder="输入学习平台名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" v-model="queryParams.query.status" clearable placeholder="请选择状态">
          <el-option label="停用" value="0"></el-option>
          <el-option label="启用" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60">
      </el-table-column>
      <el-table-column prop="learnPlatformName" label="学习平台名称">
      </el-table-column>
      <el-table-column prop="learnPlatformCode" label="学习平台编码">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">
          <div>{{scope.row.createTime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <div>{{scope.row.status == 0 ? '停用' : '启用'}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="200">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              @click="handleEdit(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="deleteUser(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>
<!--          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>


    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="30%" :close-on-click-modal="false" @click="closeDialog">
      <el-form label-width="120px" :model="form" :rules="rules" ref="form">
        <el-form-item label="学习平台名称" prop="learnPlatformName">
          <el-input size="small" v-model="form.learnPlatformName" placeholder="请输入学习平台名称"></el-input>
        </el-form-item>
        <el-form-item label="学习平台编码" prop="learnPlatformCode">
          <el-input size="small" v-model="form.learnPlatformCode" placeholder="请输入学习平台编码"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select size="small" v-model="form.status" clearable placeholder="请选择状态" style="width: 100%;">
            <el-option label="停用" value="0"></el-option>
            <el-option label="启用" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLearnPlatformList, addLearnPlatform, editLearnPlatform, deleteLearnPlatform } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import {timestampToTime} from "../../utils/util";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      form: {},
      // rules表单验证
      rules: {
        learnPlatformName: [
          { required: true, message: '请输入学习平台名称', trigger: 'blur' }
        ],
        learnPlatformCode: [
          { required: true, message: '请输入学习平台编码', trigger: 'blur' }
        ]
      },
      queryParams: {
        currentPage: 1,
        pageSize: 10,
        query: {

        }
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.initData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initData() {
      this.getdata()

    },
    // 获取营销渠道列表
    getdata() {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getLearnPlatformList(JSON.stringify(this.queryParams)).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.list
          // 分页赋值
          this.pageparm = res.data.pageParam
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.currentPage = parm.currentPage
      this.queryParams.pageSize = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.getdata()
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.form = JSON.parse(JSON.stringify(row))
      } else {
        this.title = '添加'
        this.form = {}
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {

          if (this.form.learnPlatformSeqId) {

            // 修改
            editLearnPlatform(JSON.stringify(this.form)).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          } else {

            // 新增
            addLearnPlatform(JSON.stringify(this.form)).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }


        } else {
          return false
        }
      })
    },
    // 删除营销渠道
    deleteUser(index, row) {
      this.$confirm('确定要删除该条数据吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteLearnPlatform(JSON.stringify([row.learnPlatformSeqId])).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormShow = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/learnPlat.vue